<template>
  <div class="container" style="padding-top: 5rem">
    <div class="account-box">
      <div class="account-wrapper" v-if="isUnauthorized">
        <h3 class="account-title">Unauthorized Access</h3>
      </div>
      <div class="account-wrapper" v-else>
        <h3 class="account-title">Forgot Password</h3>
        <hr />
        <form @submit.prevent="sendForgotPasswordEmail">
          <p class="text-danger text-center" v-if="errorMessage">
            {{ errorMessage }}
          </p>
          <div class="form-group">
            <label style="word-spacing: -4px">
              To reset your password, please enter your email address
            </label>
            <input
              class="form-control"
              type="email"
              v-model="email"
              maxlength="100"
              required
            />
          </div>
          <div class="form-group text-center">
            <button class="btn btn-primary account-btn" type="submit">
              Reset Password
            </button>
          </div>
          <div class="form-group text-center mb-1">
            <router-link
              :to="{
                name: 'merchantLogin',
                params: { code: $route.params.code },
              }"
            >
              Back to login
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
    
<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      errorMessage: "",
      email: "",
      isUnauthorized: false,
    };
  },
  methods: {
    sendForgotPasswordEmail() {
      this.errorMessage = "";
      this.$store.state.isLoading = true;
      API.sendForgotPasswordEmail({
        merchant_id: this.merchantId,
        email: this.email,
      })
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.$store.state.forgotPasswordSuccess = true;
            this.$router.push({ name: "merchantLogin" });
          } else {
            this.errorMessage = response.data.message;
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
          this.errorMessage = error.response.data.Message;
        });
    },
    checkMerchantExists() {
      API.checkMerchantExists({ code: this.$route.params.code })
        .then((response) => {
          if (response.data.success) {
            this.isUnauthorized = !response.data.is_exists;
          } else {
            this.errorMessage = response.data.message;
          }
        })
        .catch((error) => {
          console.log(error);
          this.errorMessage = error;
        });
    },
  },
  created() {
    if (!this.$route.params.code) this.isUnauthorized = true;
    else this.checkMerchantExists();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Merchant/ForgotPassword.vue